import { Text, VStack } from "@chakra-ui/react";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { useFormContext } from "react-hook-form";
import { InputRadioEspecie } from "./Selects/InputRadioEspecie";
import { InputRadioSexo } from "./Selects/InputRadioSexo";
import { InputSelectPorte } from "./Selects/InputSelectPorte";
import { UploadFotoAnimal } from "./UploadFotoAnimal";

interface InformacoesBasicasProps {
  idAnimal?: string;
  onFilesSelected?: (files: File[]) => void;
}

export const InformacoesBasicas = ({
  idAnimal,
  onFilesSelected
}: InformacoesBasicasProps) => {
  const {
    control,
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <VStack flex={1} gap={3} alignItems="flex-start">
      <Text fontSize="lg" fontWeight="medium">
        Informações Básicas
      </Text>
      <InputText
        label="Nome (Obrigatório)"
        name="nome"
        placeholder="Exemplo: Bilú"
        register={register}
        error={errors.nome}
      />
      <InputRadioEspecie control={control} error={errors.especie} />
      <InputText
        label="Raça"
        name="raca"
        placeholder="Digite a raça"
        register={register}
        error={errors.raca}
      />
      <InputRadioSexo control={control} error={errors.sexo} />
      <InputSelectPorte control={control} error={errors.porte} />
      <InputText
        label="Pelagem"
        name="pelagem"
        placeholder="Digite uma pelagem"
        register={register}
        error={errors.pelagem}
      />
      <InputText
        label="Cor predominante"
        name="corPredominante"
        placeholder="Digite a cor predominante"
        register={register}
        error={errors.corPredominante}
      />
      <InputText
        label="Idade - Anos"
        name="idadeAnos"
        placeholder="00"
        type="number"
        register={register}
        error={errors.idadeAnos}
      />
      <InputText
        label="Idade - Meses"
        name="idadeMeses"
        placeholder="00"
        type="number"
        register={register}
        error={errors.idadeMeses}
      />

      <UploadFotoAnimal idAnimal={idAnimal} onFilesSelected={onFilesSelected} />
    </VStack>
  );
};
